import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { dynamic } from '../../helpers/api/api';//RITM0984969

import {
    Search,
    DataTable,
    Loading,
    DataTableSkeleton,
    TextInput,
    TableContainer,
    Pagination,
    Form,
    FormLabel,
    FormGroup,
    TableHead,
    Table,
    Dropdown,
    DropdownSkeleton,
    TableSelectRow,
    TableBatchActions,
    TableBatchAction,
    TableBody,
    TableRow,
    TableCell,
    TableHeader,
    TableToolbar,
    TableToolbarContent,
    Button,
    TableSelectAll,//RITM0984969
    Checkbox,//RITM0984969
    MultiSelect,//RITM0984969
    TooltipDefinition,//RITM0984969
    TooltipDefinitionProps,//RITM0984969
    SkeletonPlaceholder,//RITM0984969
    Select,//RITM0984969
    SelectItem,//RITM0984969
} from 'carbon-components-react';
import Edit16 from '@carbon/icons-react/lib/edit/16';
import Delete16 from '@carbon/icons-react/lib/delete/16';
import Send16 from '@carbon/icons-react/lib/send/16';
import {
    CheckmarkOutline16,
    Add20,
    Error16,
    DocumentExport16,
} from '@carbon/icons-react/lib/';
import Data16 from '@carbon/icons-react/lib/data--1/16';
import TrainingRepository from '../../helpers/api/TrainingRepository';
import {
    RenderDataTableCell,
    NoRecordsPlaceholder,
} from '../../helpers/jsonschemaform/DataTableExtention';
import { showNotification } from '../../helpers/notification/BaseNotification';
import {
    getSuccess,
    getError,
    entitiesLabels,
    apioperation,
    STATUS,
    sizeFormat,//RITM0984969
} from '../../helpers/Constants';
import { training, me, api } from '../../helpers/api/api';
import { ComboBox } from '../../helpers/ComboBox';
import { CanExecuteAction, IsInRole } from '../../helpers/authorization/Policies';
import { AppContext } from '../../helpers/context/AppContext';
import { WFActionModal } from '../common/WFActionModal';
import PageBreadCrumb from '../../helpers/PageBreadCrumb';
import { Online, Offline } from '../common/OnLineOffLine';
import FileDownLoadButton from '../common/FileDownloadButton';
import SortIcon from '../common/SortIcon';
import Import16 from "@carbon/icons-react/lib/download/16";//RITM0984969
import Close16 from "@carbon/icons-react/lib/close/16";//RITM0984969
import Printer from "@carbon/icons-react/lib/printer/16";//RITM0984969
import Download16 from "@carbon/icons-react/lib/printer/16";//RITM0984969
import _sortBy from 'lodash/sortBy'; //RITM0946148
import moment from "moment";//RITM0946148

const defaultOrderBy = {
    // orderByField: 'startDate',//RITM0984969
    //   isOrderDescending: true //RITM0984969
    orderByField: 'code',
    isOrderDescending: false
};

export default class TrainingList extends Component {
    constructor(props) {
        super(props);
        this.year = new Date().getFullYear();

        this.state = {
            isApprovalModalOpen: false,
            approvalModalAction: '',
            approver: null,
            approvalStartDate: null,
            approvalEndDate: null,
            isLoadingApproverOptions: true,
            isLoadingNotificationFile: false,
            approvalValidationMessages: [],
            approvers: [],
            selectedData: [],
            approverRole: '',
            withApprover: true,
            isLoadingWFOperation: false,
            approvalNotesRequired: false,
            itemList: [],
            worksite: [],
        
            status: [],
            country: [],
            maindivision: [],
            subDivision: [], /*RITM0984969*/
            appType: [{ id: '1', name: 'Internal' },
            { id: '2', name: 'External' },], /*RITM0984969*/
            trainingYear: [],
            month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
            appMonthList: [{ id: '1', name: 'January' },
            { id: '2', name: 'February' },
            { id: '3', name: 'March' },
            { id: '4', name: 'April' },
            { id: '5', name: 'May' },
            { id: '6', name: 'June' },
            { id: '7', name: 'July' },
            { id: '8', name: 'August' },
            { id: '9', name: 'September' },
            { id: '10', name: 'October' },
            { id: '11', name: 'November' },
            { id: '12', name: 'December' },


            ],/*RITM0984969*/
            appReportingType: [{ id: '1', name: 'HSE' },
                { id: '2', name: 'LiHS & HP' },], /*RITM0984969*/
            monthList: [], /*RITM0984969*/
            selectedItems: [],
            prj: [],
            company: [],
            hseCourseCodeList: [],/*RITM0984969*/
            lihsCourseCodeList: [],/*RITM0984969*/
            currentPage: 1,
            pageSize: 10,
            rowCount: 0,
            //#region RITM0984969 certificate corner
            modalCertificateCornerVisible: false,
            isLoadingModalCertificateCorner: false,
            isLoadingTableCertificateCorner: false,
            isLoadingDownloadCertificateCorner: false,



            selectedYearForCertificateCorner: null,
            selectedGhrsIdForCertificateCorner: null,
            selectedNameForCertificateCorner: null,
            selectedSurnameForCertificateCorner: null,
            selectedCompanyForCertificateCorner: null,
            selectedTrainerNameForCertificateCorner: null,
            selectedCourseCodeForCertificateCorner: null,
            selectedWorksiteForCertificateCorner:null,

            validatorYearCertificateCorner: null,
            validatorGhrsIdCertificateCorner: null,

            validatorNameCertificateCorner: null,
            validatorSurnameCertificateCorner: null,
            trainingsCertificateCorner: [],

            currentPageCertificateCornerTable: 1,
            totalTrainingsCertificateCornerTable: 0,
            pageSizeCertificateCornerTable: 5,
       //#endregion
            isBack:
                !!(this.props.history.action === 'POP' || this.props.location.search === '?isBack'),
            searchModel: {
                ...this.searchProp(),
            },
           
        };
        this.toggleSearchForm = this.toggleSearchForm.bind(this);
        this.getStatus = this.getStatus.bind(this);
        this.getUserWorksite = this.getUserWorksite.bind(this);
        this.getCountry = this.getCountry.bind(this);
        this.getCompany = this.getCompany.bind(this);
        this.getTrainingList = this.getTrainingList.bind(this);
        this.IsRowSelectable = this.IsRowSelectable.bind(this);
        this.getTrainingYears = this.getTrainingYears.bind(this);
        this.getTrainingData = this.getTrainingData.bind(this);
        this.getLihsTrainingData = this.getLihsTrainingData.bind(this);
    }

    componentDidMount() {
        this.getTrainingList();
        this.getCountry();
        this.getCompany();
        this.getPrj();
        this.getUserWorksite();
        this.getStatus();
        this.getTrainingYears();
        this.getUserDivision();
        this.getUserSubDivision(); /*RITM0984969*/
        this.getTrainingData();
        this.getLihsTrainingData();
        
       
    }

    /** ***********API get all Training******************* */
    getTrainingList = async (param) => {
        let data = null;
        this.setState({
            isLoading: true,
        });
        if (!this.state.isBack) {
            data = {
                params: {
                    ...this.state.searchModel,
                    monthList: this.state.searchModel?.monthList != null ? this.state.searchModel.monthList.map((f) => f.id).join("|") : null, //RITM0984969
                    page: param?.page || this.state.currentPage,
                    pageSize: param?.pageSize || this.state.pageSize,
                },
            };
        } else {
            const filter = await TrainingRepository.getBackPaged();
            // filter.params.page = param?.page || filter.params.page;
            // RITM0549692
            filter.params.page = 1;
            filter.params.pageSize = param?.pageSize || filter.params.pageSize;
            data = {
                params: filter.params,
            };
            this.setState({
                //searchModel: filter?.params, //RITM0984969
                searchModel: { ...filter?.params, monthList: filter.params.monthList != null ? this.state.appMonthList.filter((w) => filter.params.monthList.includes(w.id)) : filter.params.monthList }
            });
            if (
                filter.params.idStatus === undefined &&
                filter.params.idWorksite === undefined &&
                filter.params.idCountry === undefined &&
                filter.params.idPrj === undefined &&
                filter.params.idCompany === undefined &&
                filter.params.idMainDivision === undefined &&
                filter.params.idSubDivision === undefined && /*RITM0984969*/
                filter.params.inUse === undefined &&
                filter.params.code === undefined &&
                filter.params.courseCode === undefined &&
                filter.params.compiler === undefined &&
                filter.params.dataApprover === undefined &&
                filter.params.year === undefined &&
                filter.params.month === undefined &&
                filter.params.leadTrainertype === undefined && /*RITM0984969*/
                filter.params.reSubmitted === undefined && /*RITM0984969*/
                filter.params.monthList === undefined && /*RITM0984969*/
                filter.params.reportingType === undefined && /*RITM0984969*/
                filter.params.divisionManager === undefined
            ) {
                this.setState({ isOpenSearchForm: false });
            } else {
                this.setState({ isOpenSearchForm: true });
            }
        }
        this.getTrainingListFilter(data);
    };

    getTrainingListFilter(data) {
        training
            .getWithParam(data)
            .then((response) => {
                this.setState({
                    ...response.data,
                });
                TrainingRepository.updateReportFilter(data);
                TrainingRepository.updateReport(data);
            })
            .catch((error) => {
                showNotification.error(getError(error, entitiesLabels.TRAINING, apioperation.GET));
            })
            .finally(() => {
                this.setState({
                    isLoading: false,
                });
            });
    }

    /** ***********API******************* */
    searchProp = () => ({
        idStatus: null,
        idWorksite: null,
        idCountry: null,
        idPrj: null,
        idCompany: null,
        idMainDivision: null,
        idSubDivision: null, /*RITM0984969*/
        reportingType: null,/*RITM0984969*/
        inUse: null,
        code: null,
        courseCode: null,
        year: this.state?.searchModel?.year ? this.state?.searchModel?.year : this.year,
        month: null,
        monthList: this.state?.searchModel?.monthList ? this.state?.searchModel?.monthList :  null,/*RITM0984969*/
        compiler: null,
        dataApprover: null,
        divisionManager: null,
        type: null,/*RITM0984969*/
        leadTrainertype: null,/*RITM0984969*/
        reSubmitted: null,/*RITM0984969*/
        ...defaultOrderBy
    });

    // Carico prop per combobox

    // Country
    getCountry = () => {
        api
            .getAll('/admin/country?page=0')
            .then((response) => {
                const data = response.data.itemList;
                this.setState({
                    country: _sortBy(data,"name"),
                });
            })
            .catch((error) => {
                showNotification.error(
                    `${entitiesLabels.ERROR}`,
                    getError(error, entitiesLabels.COUNTRY, apioperation.GET)
                );
            })
            .finally(() => {
                this.setState({
                    isLoadingCountry: false,
                });
            });
    };

    // Training Years
    getTrainingYears = () => {
        api.getAll('/training/years')
            .then((response) => {
                this.setState({
                    trainingYear: response.data
                });
            })
            .catch((error) => {
                showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.YEAR, apioperation.GET)
                );
            })
            .finally(() => {
                this.setState({
                    isLoadingYear: false,
                });
            });
    };

    getPrj = () => {
        me.getAll('project')
            .then((response) => {
                const { data } = response;
                this.setState({
                    prj: _sortBy(data, "name"),
                });
            })
            .catch((error) => {
                showNotification.error(
                    `${entitiesLabels.ERROR}`,
                    getError(error, entitiesLabels.PROJECT, apioperation.GET)
                );
            })
            .finally(() => {
                this.setState({
                    isLoadingProject: false,
                });
            });
    };

    // COMPANY
    getCompany = () => {
        api
            .getAll('/company')
            .then((response) => {
                const data = response.data.itemList;
                this.setState({
                    company: _sortBy(data, "name"),
                });
            })
            .catch((error) => {
                showNotification.error(
                    `${entitiesLabels.ERROR}`,
                    getError(error, entitiesLabels.COMPANY, apioperation.GET)
                );
            })
            .finally(() => {
                this.setState({
                    isLoadingCompany: false,
                });
            });
    };

    // STATUS
    getStatus = () => {
        api
            .getAll('/registry/status')
            .then((response) => {
                // DEV_255_RITM0565449
                const { data } = response;
                this.setState({
                    status: data.filter((stato) => stato.id !== 3)
                });
            })
            .catch((error) => {
                showNotification.error(
                    `${entitiesLabels.ERROR}`,
                    getError(error, entitiesLabels.STATUS, apioperation.GET)
                );
            })
            .finally(() => {
                this.setState({
                    isLoadingStatus: false,
                });
            });
    };

    // Division
    getUserDivision = () => {
        me.getAll('divisions')
            .then((response) => {
                this.setState({
                    maindivision: _sortBy(response.data,"name"),
                });
            })
            .catch((error) => {
                showNotification.error(
                    `${entitiesLabels.ERROR}`,
                    getError(error, entitiesLabels.DIVISION, apioperation.GET)
                );
            })
            .finally(() => {
                this.setState({
                    isLoadingMainDivision: false,
                });
            });
    };
    // SubDivision RITM0984969
    getUserSubDivision = () => {
        api
            .getAll('/division/subdivision')
            .then((response) => {
                //  const { data } = response;
                this.setState({
                    subDivision: _sortBy(response.data, "name"),
                });
            })
            .catch((error) => {
                showNotification.error(
                    `${entitiesLabels.ERROR}`,
                    getError(error, entitiesLabels.SUBDIVISION, apioperation.GET)
                );
            })
            .finally(() => {
                this.setState({
                    isLoadingSubDivision: false,
                });
            });
    };
   
    // Worksite
    getUserWorksite = () => {
        me.getAll('worksites')
            .then((response) => {
                this.setState({
                    worksite: _sortBy(response.data, "name"),
                });
            })
            .catch((error) => {
                showNotification.error(
                    `${entitiesLabels.ERROR}`,
                    getError(error, entitiesLabels.WORKSITEGROUP, apioperation.GET)
                );
            })
            .finally(() => {
                this.setState({
                    isLoadingWorksite: false,
                    isLoadingSelectedWorksite: false,
                });
            });
    };
    getCellValue = (type, value, isLoading = false) => { /*RITM0984969*/
        if (isLoading) {
            return <SkeletonPlaceholder style={{ height: '16px' }} />
        }

        if (!value) return "";
        if (typeof value === "object") {

            return value.name;
        }

        if (type.header === "size") {
            return sizeFormat(value)
        }

        return value;
    };

    getTrainingData = () => {
        dynamic
            .getAll("trainingdata", { params: { page: 0 } })
            .then((response) => {
                let data = response.data.itemList;
                this.setState({
                    hseCourseCodeList: _sortBy(data, "courseCode"),
                });
            })
            .catch((error) => {
                showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.TRAININGDATA, apioperation.GET));
            })
            .finally(() => {
                this.setState({
                    isLoadingSelectedHseCourseCode: false,
                });
                
            });
        
    };

    getLihsTrainingData = () => { //RITM0984969
        dynamic
            .getAll("LIHStrainingdata", { params: { page: 0 } })
            .then((response) => {
                let data = response.data.itemList;
                this.setState({
                    lihsCourseCodeList: _sortBy(data, "courseCode"),
                });
            })
            .catch((error) => {
                showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.LIHSTRAININGDATA, apioperation.GET));
            })
            .finally(() => {
                this.setState({
                    isLoadingSelectedLihsCourseCode: false,
                });
            });
    };

    // /WF
    handleApproverSelect = (selectedItem) => {
        this.setState({ approver: selectedItem });
    };

    handleCloseApprovalModal = () => {
        this.setState({ isApprovalModalOpen: false }, this.clearApprovalForm);
    };

    handleApprovalNotesChange = (e) => {
        this.setState({ approvalNotes: e.target.value });
    };
    //RITM0984969
    getDataApproverUser = () => {
        api.getWithParam('training/getTrainingDataApproverByEmail', {
            params: {},
        })
            .then((response) => {
                this.setState({
                    approvers: response.data,
                    isLoadingApproverOptions: false,
                });
            })
            .catch((error) => {
                showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.ROLE, apioperation.GET));
            })
            .finally(() => {
                this.setState({
                    isLoadingApproverOptions: false,
                });
            });
    };
	//end

    getUsersInRole = (role, idEntity) => {
        me.getWithParam('users', {
            params: { Role: role, IdEntity: idEntity, includeAdmins: true },
        })
            .then((response) => {
                this.setState({
                    approvers: response.data,
                    isLoadingApproverOptions: false,
                });
            })
            .catch((error) => {
                showNotification.error(
                    `${entitiesLabels.ERROR}`,
                    getError(error, entitiesLabels.ROLE, apioperation.GET)
                );
            })
            .finally(() => {
                this.setState({
                    isLoadingApproverOptions: false,
                });
            });
    };

    handleConfirmApprovalModal = () => {
        const apiEndpoint = this.state.approvalEndpoint;

        const data = {
            ids: this.state.selectedData.map((r) => r.id),
            owner: this.state.approver,
            workflowNotes: this.state.approvalNotes,
        };

        this.setState({
            isLoadingWFOperation: true,
        });
        api
            .put(`/training/${apiEndpoint}`, data, '')
            .then((response) => {
                if (response.status === 200) {
                    showNotification.success(
                        `${entitiesLabels.SUCCESS}`,
                        getSuccess(entitiesLabels.TRAINING, apioperation.PUT)
                    );
                    this.setState({
                        isLoadingWFOperation: false,
                        isApprovalModalOpen: false,
                        isLoading: true,
                        itemList: [],
                    });
                    this.getTrainingList();
                } else {
                    showNotification.error();
                    this.setState({
                        isLoadingWFOperation: false,
                    });
                }
            })
            .catch((error) => {
                showNotification.error(
                    `${entitiesLabels.ERROR}`,
                    getError(error, entitiesLabels.TRAINING, apioperation.PUT)
                );
                this.setState({
                    isLoadingWFOperation: false,
                });
            })
            .finally(() => { });
    };

    getTraining = (selectedRows) => {
        if (selectedRows && selectedRows.length > 0) {
            return this.state.itemList.find((el) => el.id === selectedRows[0].id);
        }
        return null;
    };

    getStatusId = (idRow) => {
        const r = this.state.itemList.find((el) => el.id === idRow);
        return r && r.idStatus;
    };

    // Search
    handleChangeCombo = (inputName, selectedItem, objName) => {
        const inputValue = selectedItem ? selectedItem.id : null;
        const statusCopy = { ...this.state };
        statusCopy[objName][inputName] = inputValue;
        statusCopy.isBack = false;
        // statusCopy['selectedItemCombo'][inputName] = selectedItem;
        this.setState(statusCopy);
    };


    handleChangeDropDownYear = (evt) => {
        const statusCopy = { ...this.state };
        statusCopy.searchModel.year = evt.selectedItem;
        statusCopy.isBack = false;
        this.setState((prevState) => ({
            isBack: statusCopy.isBack,
            searchModel: {
                ...prevState.searchModel,
                year: statusCopy.searchModel.year,
                month: evt.selectedItem ? prevState.searchModel.month : null
            }
        }), this.getTrainingList);
    };
    handleChangeDropDownSelectedYear = (evt) => { //RITM0984969
        const statusCopy = { ...this.state };
        statusCopy.searchModel.selectedYearForCertificateCorner = evt.selectedItem;
        statusCopy.isBack = false;
        this.setState((prevState) => (
            {
                isBack: statusCopy.isBack,
                searchModel: { ...prevState.searchModel, selectedYearForCertificateCorner: statusCopy.searchModel.selectedYearForCertificateCorner }
            }
        ));
    }
    handleChangeDropDownSelectedCourseCode = (evt) => { //RITM0984969
        const statusCopy = { ...this.state };
        statusCopy.searchModel.selectedCourseCodeForCertificateCorner = evt.selectedItem;
        statusCopy.isBack = false;
        this.setState((prevState) => (
            {
                isBack: statusCopy.isBack,
                searchModel: { ...prevState.searchModel, selectedCourseCodeForCertificateCorner: statusCopy.searchModel.selectedCourseCodeForCertificateCorner }
            }
        ));
    }
   
    handleChangeMonth = (inputName, selectedItem,) => {
        const item = selectedItem ? this.state.month.indexOf(selectedItem) : null;
        const m = selectedItem ? (item + 1).toString() : null;
        this.setState((prevState) => (
            { searchModel: { ...prevState.searchModel, month: m } }
        ));
    }
    //RITM0984969
    handleChangeMonthList = (selectedItem) => {
        const statusCopy = { ...this.state };
        const items = selectedItem ? selectedItem.selectedItems : null;
        statusCopy.isBack = false;
        this.setState((prevState) => (
            {
                isBack: statusCopy.isBack,
                searchModel: { ...prevState.searchModel, monthList: items.filter((s) => s.id) || [] }
            }
        ));
    };
    //End
    //handleChangeMonthList = (type, items) => {
    //    if (type === 'monthList') {

    //        this.setState((prevState) => (
    //            { searchModel: { ...prevState.searchModel, selectedItems: items?.selectedItems || [], monthList: items?.selectedItems.filter((s) => s.id) || [] } }
    //        ));
    //    }
    //};

    updateState = (inputName, inputValue, objName) => {
        const statusCopy = { ...this.state };
        statusCopy[objName][inputName] = inputValue;
        statusCopy.isBack = false;
        this.setState(statusCopy);
    };

    handleChangeSearch = (el) => {
        const inputName = el.target.name;

        const inputValue = el.target.value;
        this.setState({ isBack: false });

        this.updateState(inputName, inputValue, 'searchModel');
    };

    handleClickSearch = (e) => {
        e.preventDefault();
        this.setState({
            isLoading: true,
        });
        this.getTrainingList({ page: 1 });
    };

    handleClickCancelSearch = () => {
        this.setState({
            isBack: false,
            isLoading: true,
            searchModel: {
                ...this.searchProp(),
            },
            isOpenSearchForm: false,
        });
        const params = {
            page: 1,
            pageSize: 10,
            idStatus: null,
            idWorksite: null,
            idCountry: null,
            idPrj: null,
            idCompany: null,
            idMainDivision: null,
            idSubDivision: null,/*RITM0984969*/
            reportingType: null,/*RITM0984969*/
            inUse: null,
            code: null,
            year: this.state?.searchModel?.year ? this.state?.searchModel?.year : this.year,
            month: null,
            monthList: this.state?.searchModel?.monthList ? this.state?.searchModel?.monthList : [],/*RITM0984969*/
            courseCode: null,
            compiler: null,
            dataApprover: null,
            divisionManager: null,
            leadTrainertype: null,/*RITM0984969*/
            reSubmitted: null,/*RITM0984969*/
            //selectedYearForCertificateCorner: null,/*RITM0984969*/
            //selectedGhrsIdForCertificateCorner: null,/*RITM0984969*/
     
            ...defaultOrderBy
        };
        this.getTrainingListFilter({ params });
    };

    handleChangePaging = async (event) => {
        await this.setState({ isBack: false });
        this.getTrainingList(event);
    };

    handleOrderByChange = (key) => {
        this.setState((prevState) => {
            const isOrderDescending = prevState.searchModel.orderByField === key
                ? !prevState.searchModel.isOrderDescending
                : true;
            return {
                isBack: false,
                searchModel: {
                    ...prevState.searchModel,
                    orderByField: key,
                    isOrderDescending
                }
            };
        }, this.getTrainingList);
    };


    IsRowSelectable(row, selectedRows, user) {
        var row = this.state.itemList.find((i) => i.id === row.id);

        if (row.idStatus == STATUS.Consolidated) return false;

        if (selectedRows.length == 0) {
            return true;
        }

        if (selectedRows.length > 0) {
            const selectableTraining = this.state.itemList.find((i) => i.id == selectedRows[0].id);
            const selectableState = selectableTraining.idStatus;
           
            const selectableDivision = selectableTraining.idDivision;
            const selectableWorksite = selectableTraining.idWorkSite;

            if (
                row.idStatus == selectableState && 
               (row.idStatus == STATUS.Draft
                   ? row.idWorkSite == selectableWorksite
                    : row.idDivision == selectableDivision)
            ) {
                const canSelect =
                    CanExecuteAction('Training', 'Reporting', user, row.idStatus, 'Submit', row) ||
                    CanExecuteAction('Training', 'Reporting', user, row.idStatus, 'Approve', row) ||
                    CanExecuteAction('Training', 'Reporting', user, row.idStatus, 'Consolidate', row) ||
                    CanExecuteAction('Trainign', 'Reporting', user, row.idStatus, 'Reject', row) ||
                    CanExecuteAction('Training', 'Reporting', user, row.idStatus, 'RejectConsolidate', row) ||
                    CanExecuteAction('Training', 'Reporting', user, row.idStatus, 'Delete', row);
                return canSelect;
                // return true;
            }

            return false;
        }

        return false;
    }
    //RITM0984969 certificate corner
    openCertificateCornerModal = () => {
        this.setState({
            modalCertificateCornerVisible: true

        });
    }

    closeCertificateCornerModal = () => {
        this.setState({
            modalCertificateCornerVisible: false,
            isLoadingModalCertificateCorner: false,
            isLoadingTableCertificateCorner: false,
            isLoadingDownloadCertificateCorner: false,



            selectedYearForCertificateCorner: null,
            selectedGhrsIdForCertificateCorner: null,
            selectedNameForCertificateCorner: null,
            selectedSurnameForCertificateCorner: null,
            selectedCompanyForCertificateCorner: null,
            validatorYearCertificateCorner: null,
            validatorGhrsIdCertificateCorner: null,
            selectedTrainerNameForCertificateCorner:null,
            selectedCourseCodeForCertificateCorner:null,
            selectedWorksiteForCertificateCorner: null,

            trainingsCertificateCorner: [],

            currentPageCertificateCornerTable: 1,
            totalTrainingsCertificateCornerTable: 0,
            pageSizeCertificateCornerTable: 5
        })
    }



    searchTrainingsForCertificateCornerModal = () => {
        if (this.checkValidatorCertificateCorner()) {
            this.setState({
                isLoadingDownloadCertificateCorner: true,
                isLoadingTableCertificateCorner: true
            });
            const skip = (this.state.currentPageCertificateCornerTable - 1) * this.state.pageSizeCertificateCornerTable;
            api.post(`/training/GetTrainingCertificates/skip/${skip}/take/${this.state.pageSizeCertificateCornerTable}`,
                {
                    year: (this.state.searchModel.selectedYearForCertificateCorner), ghrsId: (this.state.searchModel.selectedGhrsIdForCertificateCorner),
                    name: (this.state.searchModel.selectedNameForCertificateCorner), surname: (this.state.searchModel.selectedSurnameForCertificateCorner),
                    company: (this.state.searchModel.selectedCompanyForCertificateCorner), trainerName: (this.state.searchModel.selectedTrainerNameForCertificateCorner),
                    courseName: (this.state.searchModel.selectedCourseCodeForCertificateCorner), worksite: (this.state.searchModel.selectedWorksiteForCertificateCorner),
                })
                .then((response) => {
                    const data = response.data;
                    this.setState({
                        trainingsCertificateCorner: data.trainings,
                        totalTrainingsCertificateCornerTable: data.totCount,
                        currentPageCertificateCorner: 1,
                    })
                })
                .catch((error) => {
                    showNotification.error(getError(error, entitiesLabels.TRAININGCERTIFICATECORNER_GETTRAININGS, apioperation.GET));
                })
                .finally(() => {
                    this.setState({
                        isLoadingDownloadCertificateCorner: false,
                        isLoadingTableCertificateCorner: false
                    });
                });
        }
    }

    getTemplateExcelForTrainingList = () => {
        if (this.checkValidatorCertificateCorner()) {
            this.setState({
                isLoadingDownloadCertificateCorner: true,
                isLoadingTableCertificateCorner: true
            });
            let input = {
                year: (this.state.searchModel.selectedYearForCertificateCorner), ghrsId: (this.state.searchModel.selectedGhrsIdForCertificateCorner),
                name: (this.state.searchModel.selectedNameForCertificateCorner), surname: (this.state.searchModel.selectedSurnameForCertificateCorner),
                company: (this.state.searchModel.selectedCompanyForCertificateCorner), trainerName: (this.state.searchModel.selectedTrainerNameForCertificateCorner),
                courseName: (this.state.searchModel.selectedCourseCodeForCertificateCorner), worksite: (this.state.searchModel.selectedWorksiteForCertificateCorner),
            };
            const skip = (this.state.currentPageCertificateCornerTable - 1) * this.state.pageSizeCertificateCornerTable;
            api.post(`/training/GetTrainingCertificates/skip/${skip}/take/${this.state.pageSizeCertificateCornerTable}`,
                {
                    year: (this.state.searchModel.selectedYearForCertificateCorner), ghrsId: (this.state.searchModel.selectedGhrsIdForCertificateCorner),
                    name: (this.state.searchModel.selectedNameForCertificateCorner), surname: (this.state.searchModel.selectedSurnameForCertificateCorner),
                    company: (this.state.searchModel.selectedCompanyForCertificateCorner), trainerName: (this.state.searchModel.selectedTrainerNameForCertificateCorner),
                    courseName: (this.state.searchModel.selectedCourseCodeForCertificateCorner), worksite: (this.state.searchModel.selectedWorksiteForCertificateCorner),
                })
                .then((response) => {
                    const data = response.data;
                    this.setState({
                        trainingsCertificateCorner: data.trainings,
                        totalTrainingsCertificateCornerTable: data.totCount,
                        currentPageCertificateCorner: 1,
                    })
                })
                .catch((error) => {
                    showNotification.error(getError(error, entitiesLabels.TRAININGCERTIFICATECORNER_GETTRAININGS, apioperation.GET));
                })
                .finally(() => {
                   
                });
            api.postBlob(`/training/downloadTrainingListCertificateCorner`, input)
                .then((response) => {
            
                    const link = document.createElement('a');
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    link.href = url
                    link.setAttribute('download', "TrainingReport.xlsx");
                    document.body.appendChild(link);
                    link.click();
                    window.URL.revokeObjectURL(url);
                })
                //End
                .catch((error) => {
                    showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.HOCCARDTEMPLATE, apioperation.DOWNLOAD));
                })
                .finally(() => {
                    this.setState({
                        isLoadingDownloadCertificateCorner: false,
                        isLoadingTableCertificateCorner: false
                    });
                });
    
        }
    }

    hanldeChangeCertificateCorner = (el) => {
        let inputName = el.target.name;
        let inputValue = el.target.value;
        this.updateState(inputName, inputValue, 'searchModel');
    };



    checkValidatorCertificateCorner = () => {
        var selectedYear = this.state.searchModel.selectedYearForCertificateCorner;
        var selectedGhrsId = this.state.searchModel.selectedGhrsIdForCertificateCorner;
        var validator=false;
        var validator1=false;
        var selectedName = this.state.searchModel.selectedNameForCertificateCorner;
        var selectedSurname = this.state.searchModel.selectedSurnameForCertificateCorner;
        if (selectedYear ===undefined ||selectedYear === null) {
            this.setState({
               validatorYearCertificateCorner: 'Choose at least one year',
             });
           return false;
        }
        if (selectedGhrsId != undefined || selectedGhrsId != null)
        {
            validator=true;
        }
        
        if((selectedName != undefined || selectedName != null) && (selectedSurname != undefined ||selectedSurname != null))
        {
            validator1=true; 
        }
       
        if(validator==false && validator1==false)   {
       this.setState({

                validatorGhrsIdCertificateCorner: 'Choose at least Ghrs ID or Name & Surname'
            });
            return false;
        }
        this.setState({
            validatorCertificateCorner: null,
            validatorGhrsIdCertificateCorner: null,
            validatorYearCertificateCorner:null
        });

        return true;
    }

    handleChangePagingCertificateCornerTable = (page) => {
        this.setState({
            currentPageCertificateCornerTable: page.page,
            pageSizeCertificateCornerTable: page.pageSize
        }, () => {
            this.searchTrainingsForCertificateCornerModal();
        })
    };

    downloadCertificateCorner = (selectedRows) => {
        if (!this.ifMaximumLimit(selectedRows)) {
            this.setState({
                isLoadingDownloadCertificateCorner: true,
                isLoadingTableCertificateCorner: true
            });

            let input = {
                ids: selectedRows?.map(x => x['id']),
                isSingle: false
            };

            api.postBlob(`/training/downloadZipCertificateCorner`, input)
                .then((response) => {
                    const link = document.createElement('a');
                    // Browsers that support HTML5 download attribute
                    if (link.download !== undefined) {
                        var currentdate = new Date();
                        var datetime = (currentdate.getMonth() + 1).toString() +
                            currentdate.getDate().toString() +
                            currentdate.getFullYear().toString() +
                            currentdate.getHours().toString() +
                            currentdate.getMinutes().toString() +
                            currentdate.getSeconds().toString();
                        var fileName = 'Trainings_' + datetime + '.zip';

                        const url = URL.createObjectURL(response.data);
                        link.setAttribute('href', url);
                        link.setAttribute('download', fileName);
                        link.style.visibility = 'hidden';
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    }
                })
                .catch((error) => {
                    showNotification.error(getError(error, entitiesLabels.TRAININGCERTIFICATECORNER_GETTRAININGS, apioperation.GET));
                })
                .finally(() => {
                    this.setState({
                        isLoadingDownloadCertificateCorner: false,
                        isLoadingTableCertificateCorner: false
                    });
                });
        }
        else {
            showNotification.error('Download maximum of 5 certificates at a time');
        }
    }

    ifMaximumLimit = (selectedRows) => {
        if (selectedRows?.length <= 5) return false;

        return true
    }

    isRowSelectablecertificateCornerTable(tableRow) {
        if (tableRow !== null && tableRow !== undefined) {
            if (tableRow.cells[3].value !== 0
                && tableRow.cells[3].value !== ''
                && tableRow.cells[3].value !== '0'
                && tableRow.cells[3].value !== undefined
                && tableRow.cells[3].value !== null) {
                return true;
            }
        }

        return false;
    }

    renderCertificateCornerModal = () => {
        const headersCertificateCornerTable = [
            {
                key: "name",
                header: "Participant Name",

            },
            {
                key: "surname",
                header: "Surname",

            },
            {
                key: "ghrsId",
                header: "GHRS ID",
            },
            {
                key: "traTitle",
                header: "Course Code",

            },
            {
                key: "traCode",
                header: "TRA Code",

            },
            {
                key: "certName",
                header: "Training Certificate name",

            }

        ]

        const loadingRows = [
            {
                id: 0,
                name: '',
                surname: '',
                ghrsId: '',
                traTitle: '',
                traCode: '',
                certName: ''
            },
            {
                id: 1,
                name: '',
                surname: '',
                ghrsId: '',
                traTitle: '',
                traCode: '',
                certName: ''
            },
            {
                id: 2,
                name: '',
                surname: '',
                ghrsId: '',
                traTitle: '',
                traCode: '',
                certName: ''
            },
            {
                id: 3,
                name: '',
                surname: '',
                ghrsId: '',
                traTitle: '',
                traCode: '',
                certName: ''
            },
            {
                id: 4,
                name: '',
                surname: '',
                ghrsId: '',
                traTitle: '',
                traCode: '',
                certName: ''
            },
        ]

        const paginationCertificateCornerTableProps = () => ({
            page: this.state.CertificateCornerTable || 1,
            totalItems: this.state.totalTrainingsCertificateCornerTable || 0,
            pageSize: this.state.pageSizeCertificateCornerTable || 5,
            pageSizes: [5, 10, 20, 30, 40, 50],
            onChange: this.handleChangePagingCertificateCornerTable,
        });
        
        return (
            this.state.modalCertificateCornerVisible && (
                <div className="bx--modal bx--modal-tall is-visible">
                    <div className="bx--modal-container" style={{ height: '90%' }}>
                        <div className="bx--modal-header">
                            <h3 className="bx--modal-header__heading">Certificate Download</h3>
                            <Button className="bx--modal-close" renderIcon={Close16} onClick={this.closeCertificateCornerModal} />
                        </div>
                        <div className="bx--modal-content bx-modal-content-detail">
                            <div className="bx--row">
                                <div className="bx--col-lg-12 bx--col-md-12">
                                    <h5 className="align-center">
                                        Choose at least Year, GHRS ID or Participant Name and Participant Surname
                                    </h5>
                                    <div className="align-center">
                                        Download maximum of 5 certificates at a time
                                    </div>
                                </div>
                            </div>
                            <div className="bx--row">

                                <div className="bx--col-lg-6 bx--col-md-4">
                                    <FormGroup legendText="">
                                        <FormLabel className="some-class">Year</FormLabel>
                                        <Dropdown
                                            id="selectedYearForCertificateCorner"
                                            label=""
                                            name="selectedYearForCertificateCorner"
                                            alt="searchModel"
                                            items={this.state.trainingYear}
                                            onChange={this.handleChangeDropDownSelectedYear}
                                            selectedItem={this.state.searchModel?.selectedYearForCertificateCorner ?
                                                this.state.searchModel?.selectedYearForCertificateCorner.toString() :
                                                null}
                                            itemToString={(item) => item || ''}
                                            invalid={this.state.validatorYearCertificateCorner !== null}
                                            invalidText={this.state.validatorYearCertificateCorner}
                                        />
                                       
                                    </FormGroup>
                                </div>
                                <div className="bx--col-lg-6 bx--col-md-4">
                                    <FormGroup legendText="">
                                        <FormLabel className="some-class">GHRS ID</FormLabel>
                                        <TextInput
                                            id="selectedGhrsIdForCertificateCorner"
                                            name="selectedGhrsIdForCertificateCorner"
                                            value={this.state.searchModel.selectedGhrsIdForCertificateCorner || ''}
                                            onChange={this.handleChangeSearch}
                                            placeholder="Input GHRS ID"
                                            type="text"
                                            labelText=""
                                            className="bx--text-input some-class bx--text-input--light"
                                            invalid={this.state.validatorGhrsIdCertificateCorner !== null}
                                            invalidText={this.state.validatorGhrsIdCertificateCorner}
                                        />
                                    </FormGroup>
                                </div>
                            </div>
                            <div className="bx--row">

                                <div className="bx--col-lg-6 bx--col-md-4">
                                    <FormGroup legendText="">
                                        <FormLabel className="some-class">Participant Name</FormLabel>
                                        <TextInput
                                            id="selectedNameForCertificateCorner"
                                            name="selectedNameForCertificateCorner"
                                            value={this.state.searchModel.selectedNameForCertificateCorner || ''}
                                            onChange={this.handleChangeSearch}
                                            placeholder="Input Name"
                                            type="text"
                                            labelText=""
                                            className="bx--text-input some-class bx--text-input--light"
                                            invalid={this.state.validatorGhrsIdCertificateCorner !== null}
                                            invalidText={this.state.validatorGhrsIdCertificateCorner}
                                        />
                                    </FormGroup>
                                </div>
                                <div className="bx--col-lg-6 bx--col-md-4">
                                    <FormGroup legendText="">
                                        <FormLabel className="some-class">Participant Surname</FormLabel>
                                        <TextInput
                                            id="selectedSurnameForCertificateCorner"
                                            name="selectedSurnameForCertificateCorner"
                                            value={this.state.searchModel.selectedSurnameForCertificateCorner || ''}
                                            onChange={this.handleChangeSearch}
                                            placeholder="Input Surname"
                                            type="text"
                                            labelText=""
                                            className="bx--text-input some-class bx--text-input--light"
                                            invalid={this.state.validatorGhrsIdCertificateCorner !== null}
                                            invalidText={this.state.validatorGhrsIdCertificateCorner}
                                        />
                                    </FormGroup>
                                </div>
                            </div>
                          
                            <div className="bx--row">
                                {/*<div>*/}
                                {/*    <Online>*/}
                                {/*          <Button renderIcon={Import16} onClick={() => this.getTemplateExcelForTrainingList()}>*/}
                                {/*            Download Training List */}
                                {/*        </Button>*/}
                                {/*    </Online>*/}
                                {/*</div>*/}
                                <div className="bx--col-lg-12 bx--col-md-12">
                                    <DataTable
                                        useZebraStyles="true"
                                        rows={this.state.isLoadingTableCertificateCorner ? loadingRows : (this.state.trainingsCertificateCorner || [])}
                                        headers={headersCertificateCornerTable}
                                        render={({ rows, getHeaderProps, getSelectionProps, selectedRows, getBatchActionProps }) => (
                                            <TableContainer>
                                                <>
                                                    <TableToolbar>
                                                        <TableBatchActions {...getBatchActionProps()}>
                                                            <Online>
                                                                <TableBatchAction disabled={this.state.isLoadingDownloadCertificateCorner || selectedRows?.length === 0} renderIcon={Download16} onClick={() => this.downloadCertificateCorner(selectedRows)}>
                                                                    Download
                                                                </TableBatchAction>
                                                            </Online>
                                                        </TableBatchActions>
                                                    </TableToolbar>
                                                    <Table>
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableHeader />

                                                                {headersCertificateCornerTable.map((header) => (
                                                                    <TableHeader {...getHeaderProps({ header })}>{header.header}</TableHeader>
                                                                ))}
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {rows == null || rows.length === 0 ? (
                                                                <NoRecordsPlaceholder colSpan={headersCertificateCornerTable.length + 2} />
                                                            ) : (
                                                                rows.map((row) => (
                                                                    <TableRow key={row.id}>
                                                                        <Online>
                                                                            <TableSelectRow {...getSelectionProps({ row })} />
                                                                        </Online>
                                                                        <Offline>
                                                                            <TableCell key={`empty${row.id}`} className="tableActions align-center" />
                                                                        </Offline>

                                                                        {row.cells.map((cell) => (
                                                                            <TableCell key={cell.id}>{this.getCellValue(cell.info, cell.value, this.state.isLoadingTableCertificateCorner)}</TableCell>
                                                                        ))}
                                                                    </TableRow>
                                                                ))
                                                            )}
                                                        </TableBody>
                                                    </Table>
                                                </>
                                            </TableContainer>
                                        )}
                                    />
                                </div>

                            </div>
                            <div className="bx--row">
                                <div className="bx--col-lg-12 bx--col-md-12 footer-pagination footer-pagination-modal">
                                    <Pagination {...paginationCertificateCornerTableProps()} />
                                </div>
                            </div>
                        </div>



                        <div className="bx--modal-footer">
                            <Button className="button--max-width" kind="secondary" disabled={this.state.isLoadingDownloadCertificateCorner} onClick={this.closeCertificateCornerModal}>
                                Cancel
                            </Button>
                            <Button onClick={() => this.getTemplateExcelForTrainingList()} disabled={this.state.isLoadingTableCertificateCorner}>
                                Search & Download Training List
                            </Button>
                            <Button className="button--max-width" kind="primary" disabled={this.state.isLoadingTableCertificateCorner}
                                onClick={() => this.searchTrainingsForCertificateCornerModal()}
                            >
                                Search
                            </Button>
                        </div>
                    </div>
                </div>
            )
        );
    };
    //end certificate corner


    batchActionClick(
        actionKey,
        actionName,
        approverRole,
        withApprover,
        approvalNotesRequired,
        selectedRows
    ) {
        const trainingItem = this.state.itemList.find((i) => i.id === selectedRows[0].id);

        let idEntity;
        if (actionKey === 'Submit') {
            idEntity = trainingItem.idWorkSite;
        } else if (actionKey === 'Approve') {
            idEntity = trainingItem.idDivision;
        } else {
            idEntity = null;
        }

        this.setState({
            approvalModalAction: actionName,
            isApprovalModalOpen: true,
            isLoadingApproverOptions: true,
            withApprover,
            selectedData: selectedRows,
            approverRole,
            approvalEndpoint: actionKey,
            approvalNotesRequired,
        });
       
       // if (withApprover) this.getUsersInRole(approverRole, idEntity);//RITM0984969
        if (withApprover && approverRole != "Data Approver") this.getUsersInRole(approverRole, idEntity);//RITM0984969

        if (approverRole == "Data Approver" && !IsInRole(this.context.user, "Administrator")) this.getDataApproverUser(); //RITM0984969
        if (approverRole == "Data Approver" && IsInRole(this.context.user, "Administrator")) this.getUsersInRole(approverRole, idEntity); //RITM0984969
    }

    toggleSearchForm(e) {
        e.preventDefault();
        this.setState((oldState) => ({ isOpenSearchForm: !oldState.isOpenSearchForm }));
    }

    returnMonthList = (id) => this.state.searchModel?.monthList?.find(el => el.id == id) ? true : false //RITM0984969

    renderSearchform() {
        const filterItems = {
            idStatus: this.state.searchModel?.idStatus
                ? (this.state.status || []).find((el) => el.id === this.state.searchModel.idStatus)
                : [],
            idWorksite: this.state.searchModel?.idWorksite
                ? (this.state.worksite || []).find((el) => el.id === this.state.searchModel.idWorksite)
                : [],
            idCountry: this.state.searchModel?.idCountry
                ? (this.state.country || []).find((el) => el.id === this.state.searchModel.idCountry)
                : [],
            idMainDivision: this.state.searchModel?.idMainDivision
                ? (this.state.maindivision || []).find(
                    (el) => el.id === this.state.searchModel.idMainDivision)
                : [],
            idSubDivision: this.state.searchModel?.idSubDivision /*RITM0984969*/
                ? (this.state.subdivision || []).find(
                    (el) => el.id === this.state.searchModel.idSubDivision)
                : [],
           
            idPrj: this.state.searchModel?.idPrj
                ? (this.state.prj || []).find((el) => el.id === this.state.searchModel.idPrj)
                : [],
            idCompany: this.state.searchModel?.idCompany
                ? (this.state.company || []).find((el) => el.id === this.state.searchModel.idCompany)
                : [],
            idActionStatus: null,
            inUse: this.state.searchModel?.inUse
                ? (this.state.inUse || []).find((el) => el.id === this.state.searchModel.inUse)
                : [],
            leadTrainertype: this.state.searchModel?.leadTrainertype /*RITM0984969*/
                ? (this.state.appType || []).find(
                    (el) => el.name === this.state.searchModel.leadTrainertype)
                : [],
            reSubmitted: this.state.searchModel?.reSubmitted != null ? this.state.searchModel?.reSubmitted : null,/*RITM0984969*/
            //monthList: this.state.searchModel?.monthList?.length > 0 ? this.state.searchModel?.monthList.map((elem) => elem.id).join(', ') : null,/*RITM0984969*/
            selectedMonthLists: this.state.searchModel?.monthList != null  /*RITM0984969*/
                ? (this.state.appMonthList || []).filter((el) => this.state.searchModel.monthList.find(elem => elem.id === el.id))
                : [],
            reportingType: this.state.searchModel?.reportingType
                ? (this.state.appReportingType || []).find(
                    (el) => el.name === this.state.searchModel.reportingType)
                : [],/*RITM0984969*/
            selectedYearForCertificateCorner: this.state.searchModel?.selectedYearForCertificateCorner
                ? (this.state.trainingYear || []).find((el) => el.name === this.state.searchModel.selectedYearForCertificateCorner)
                : [], /*RITM0984969*/
            selectedCourseCodeForCertificateCorner: this.state.searchModel?.selectedCourseCodeForCertificateCorner
                ? ((this.state.hseCourseCodeList.concat(this.state.lihsCourseCodeList)) || []).find((el) => el.id === this.state.searchModel.selectedCourseCodeForCertificateCorner)
                : [], /*RITM0984969*/
            selectedWorksiteForCertificateCorner: this.state.searchModel?.selectedWorksiteForCertificateCorner
                ? (this.state.worksite || []).find((el) => el.id === this.state.searchModel.selectedWorksiteForCertificateCorner)
                : [], /*RITM0984969*/
        };
        return (
            <div style={{ display: this.state.isOpenSearchForm ? 'block' : 'none' }}>
                <Form autoComplete="off" className="bx--row" onSubmit={this.handleClickSearch}>
                    <FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
                        <FormLabel className="some-class">Status</FormLabel>
                        {this.state.isLoadingStatus ? (
                            <DropdownSkeleton />
                        ) : (
                            <ComboBox
                                id="idSearchStatus"
                                placeholder="All"
                                name="idStatus"
                                alt="searchModel"
                                onChange={this.handleChangeCombo}
                                itemToString={(item) => (item ? item.reportingName : '')}
                                initialSelectedItem={
                                    this.state.searchModel?.idStatus != null ? filterItems.idStatus : 'All'
                                }
                                selectedItem={
                                    this.state.searchModel?.idStatus != null ? filterItems.idStatus : 'All'
                                }
                                items={this.state.status}
                            />
                        )}
                    </FormGroup>

                    <FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
                        <FormLabel className="some-class">Worksite</FormLabel>
                        {this.state.isLoadingWorksite ? (
                            <DropdownSkeleton />
                        ) : (
                            <ComboBox
                                id="idSearchWorksite"
                                placeholder="All"
                                name="idWorksite"
                                alt="searchModel"
                                onChange={this.handleChangeCombo}
                                itemToString={(item) => (item ? item.name : '')}
                                shouldFilterItem={({ item, inputValue }) =>
                                    item.name.toLowerCase().includes(inputValue.toLowerCase()) ||
                                    item.code.toLowerCase().includes(inputValue.toLowerCase())
                                }
                                initialSelectedItem={
                                    this.state.searchModel?.idWorksite != null ? filterItems.idWorksite : 'All'
                                }
                                selectedItem={
                                    this.state.searchModel?.idWorksite != null ? filterItems.idWorksite : 'All'
                                }
                                items={this.state.worksite}
                            />
                        )}
                    </FormGroup>

                    <FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
                        <FormLabel className="some-class">Project</FormLabel>
                        {this.state.isLoadingProject ? (
                            <DropdownSkeleton />
                        ) : (
                            <ComboBox
                                id="idSearchPrj"
                                placeholder="All"
                                name="idPrj"
                                alt="searchModel"
                                onChange={this.handleChangeCombo}
                                itemToString={(item) => (item ? item.name : '')}
                                shouldFilterItem={({ item, inputValue }) =>
                                    item.name.toLowerCase().includes(inputValue.toLowerCase()) ||
                                    item.code.toLowerCase().includes(inputValue.toLowerCase())
                                }
                                initialSelectedItem={this.state.searchModel.idPrj ? filterItems.idPrj : 'All'}
                                selectedItem={this.state.searchModel.idPrj ? filterItems.idPrj : 'All'}
                                items={this.state.prj}
                            />
                        )}
                    </FormGroup>

                    <FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
                        <FormLabel className="some-class">Country</FormLabel>
                        {this.state.isLoadingCountry ? (
                            <DropdownSkeleton />
                        ) : (
                            <ComboBox
                                id="idSearchCountry"
                                placeholder="All"
                                name="idCountry"
                                alt="searchModel"
                                onChange={this.handleChangeCombo}
                                itemToString={(item) => (item ? item.name : '')}
                                shouldFilterItem={({ item, inputValue }) =>
                                    item.name.toLowerCase().includes(inputValue.toLowerCase()) ||
                                    item.code.toLowerCase().includes(inputValue.toLowerCase())
                                }
                                initialSelectedItem={
                                    this.state.searchModel.idCountry ? filterItems.idCountry : 'All'
                                }
                                selectedItem={this.state.searchModel.idCountry ? filterItems.idCountry : 'All'}
                                items={this.state.country}
                            />
                        )}
                    </FormGroup>

                    {/* <FormGroup legendText="" className="bx--col-md-4">
                        <FormLabel className="some-class">
                            Reference Year
                                </FormLabel>
                        <ComboBox
                            id="idSearchReferenceYear"
                            placeholder="Select"
                            name="idReferenceYear"
                            alt="searchModel"
                            onChange={this.handleChangeCombo}
                            itemToString={item => (item ? item.name : '')}
                            initialSelectedItem={filterItems.idReferenceYear}
                            items={this.state.referenceyear}
                        //        // items={this.state.search.search}

                        />
                    </FormGroup> */}

                    <FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
                        {/*<FormLabel>Training Code</FormLabel> RITM0984969*/}
                        <FormLabel>TRA Code</FormLabel>
                        <TextInput
                            id="inputcodesearch"
                            name="code"
                            value={this.state.searchModel.code || ''}
                            onChange={this.handleChangeSearch}
                            placeholder="Input Training Code"
                            type="text"
                            labelText=""
                            className="bx--text-input some-class bx--text-input--light"
                        />
                    </FormGroup>
                    <FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
                        {/* <FormLabel>Course Code</FormLabel>*/}{/*RITM0984969*/}
                        <FormLabel>Training Title and Code</FormLabel>
                        <TextInput
                            id="inputcourseCodesearch"
                            name="courseCode"
                            value={this.state.searchModel.courseCode || ''}
                            onChange={this.handleChangeSearch}
                            placeholder="Input Training Course Code"
                            type="text"
                            labelText=""
                            className="bx--text-input some-class bx--text-input--light"
                        />
                    </FormGroup>
                    {/* RITM0984969*/}
                    {/*<FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">*/}
                    {/*  <FormLabel>Email Compiler</FormLabel>*/}
                    {/*  <TextInput*/}
                    {/*    id="inputsearchcompiler"*/}
                    {/*    name="compiler"*/}
                    {/*    value={this.state.searchModel.compiler || ''}*/}
                    {/*    onChange={this.handleChangeSearch}*/}
                    {/*    placeholder="Input Compiler"*/}
                    {/*    type="text"*/}
                    {/*    labelText=""*/}
                    {/*    className="bx--text-input some-class bx--text-input--light"*/}
                    {/*  />*/}
                    {/*</FormGroup>*/}

                    {/*<FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">*/}
                    {/*  <FormLabel>Email Data Approver</FormLabel>*/}
                    {/*  <TextInput*/}
                    {/*    id="inputsearchdataApprover"*/}
                    {/*    name="dataApprover"*/}
                    {/*    value={this.state.searchModel.dataApprover || ''}*/}
                    {/*    onChange={this.handleChangeSearch}*/}
                    {/*    placeholder="Input Data Approver"*/}
                    {/*    type="text"*/}
                    {/*    labelText=""*/}
                    {/*    className="bx--text-input some-class bx--text-input--light"*/}
                    {/*  />*/}
                    {/*</FormGroup>*/}

                    {/*<FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">*/}
                    {/*  <FormLabel>Email Consolidator</FormLabel>*/}
                    {/*  <TextInput*/}
                    {/*    id="inputsearchdivisionManager"*/}
                    {/*    name="divisionManager"*/}
                    {/*    value={this.state.searchModel.divisionManager || ''}*/}
                    {/*    onChange={this.handleChangeSearch}*/}
                    {/*    placeholder="Input Consolidator"*/}
                    {/*    type="text"*/}
                    {/*    labelText=""*/}
                    {/*    className="bx--text-input some-class bx--text-input--light"*/}
                    {/*  />*/}
                    {/*</FormGroup>*/}
                    <FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
                        {/* RITM0945977 */}
                        {/* <FormLabel className="some-class">Division</FormLabel> */}
                        <FormLabel className="some-class">Business Line</FormLabel>
                        {this.state.isLoadingMainDivision ? (
                            <DropdownSkeleton />
                        ) : (
                            <ComboBox
                                id="idSearchDivision"
                                placeholder="All"
                                name="idDivision"
                                alt="searchModel"
                                onChange={this.handleChangeCombo}
                                itemToString={(item) => (item ? item.name : '')}
                                shouldFilterItem={({ item, inputValue }) =>
                                    item.name.toLowerCase().includes(inputValue.toLowerCase()) ||
                                    item.code.toLowerCase().includes(inputValue.toLowerCase())
                                }
                                initialSelectedItem={this.state.searchModel.idMainDivision ? filterItems.idMainDivision : 'All'}
                                selectedItem={this.state.searchModel.idMainDivision ? filterItems.idMainDivision : 'All'}
                                items={this.state.maindivision}
                            />
                        )}
                    </FormGroup>
                    {/*  RITM0984969 :new filter Sub-Business Line*/}
                    <FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
                        <FormLabel className="some-class">Sub-Business Line</FormLabel>
                        {this.state.isLoadingSubDivision ? (
                            <DropdownSkeleton />
                        ) : (
                            <ComboBox
                                id="idSubDivision"
                                placeholder="All"
                                name="idSubDivision"
                                alt="searchModel"
                                onChange={this.handleChangeCombo}
                                itemToString={(item) => (item ? item.name : '')}
                                shouldFilterItem={({ item, inputValue }) =>
                                    item.name.toLowerCase().includes(inputValue.toLowerCase()) ||
                                    item.code.toLowerCase().includes(inputValue.toLowerCase())
                                }
                                initialSelectedItem={this.state.searchModel.idSubDivision ? filterItems.idSubDivision : 'All'}
                                selectedItem={this.state.searchModel.idSubDivision ? filterItems.idSubDivision : 'All'}
                                items={this.state.subDivision}
                            />
                        )}
                    </FormGroup>
                    {/*  RITM0984969 :new filter Reporting Type*/}
                    <FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
                        <FormLabel className="some-class">Reporting Type</FormLabel>
                        <ComboBox
                            id="reportingType"
                            placeholder="All"
                            name="reportingType"
                            alt="searchModel"
                            onChange={this.handleChangeCombo}
                            itemToString={item => (item ? item.name : '')}
                            initialSelectedItem={
                                this.state.searchModel?.reportingType != null ? filterItems.reportingType : 'All'
                            }
                            selectedItem={
                                this.state.searchModel?.reportingType != null ? filterItems.reportingType : 'All'
                            }
                            items={this.state.appReportingType}

                        />
                    </FormGroup>
                    
                    {/*  RITM0984969 */}
                    {/*<FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">*/}
                    {/*    <FormLabel className="some-class">Month</FormLabel>*/}
                    {/*    <ComboBox*/}
                    {/*        id="idSearchMonth"*/}
                    {/*        placeholder="All"*/}
                    {/*        name="month"*/}
                    {/*        alt="searchModel"*/}
                    {/*        onChange={this.handleChangeMonth}*/}
                    {/*        itemToString={(item) => (item || '')}*/}
                    {/*        selectedItem={this.state.searchModel.month ? this.state.month[this.state.searchModel.month - 1] : 'All'}*/}
                    {/*        items={this.state.month}*/}
                    {/*        disabled={this.state.searchModel.year == null}*/}
                    {/*    />*/}
                    {/*</FormGroup>*/}
                    {/*  RITM0984969 :new filter Trainer Type*/}
                    <FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
                        <FormLabel className="some-class">Trainer Type </FormLabel>
                        <ComboBox
                            id="leadTrainertype"
                            placeholder="All"
                            name="leadTrainertype"
                            alt="searchModel"
                            onChange={this.handleChangeCombo}
                            itemToString={item => (item ? item.name : '')}
                            initialSelectedItem={
                                this.state.searchModel?.leadTrainertype != null ? filterItems.leadTrainertype : 'All'
                            }
                            selectedItem={
                                this.state.searchModel?.leadTrainertype != null ? filterItems.leadTrainertype : 'All'
                            }
                            items={this.state.appType}

                        />
                    </FormGroup>
                    {/*  RITM0984969 :new filter multiselect month*/}
                    <FormGroup className="bx--col-md-4 bx--col-lg-4" legendText="">
                        <FormLabel>Month</FormLabel>
                        {this.state.appMonthList == null ? (
                            <DropdownSkeleton />
                        ) : (
                            // aggiunto
                            <MultiSelect.Filterable
                                id="monthList"

                                placeholder={
                                    this.state.searchModel?.monthList == null
                                        ? 'Choose one or more items'
                                        : filterItems.selectedMonthLists?.map((elem) => elem.name).join(', ')
                                }
                                itemToString={(item) => (item ? item.name : "")}
                                items={this.state.appMonthList}
                                onChange={this.handleChangeMonthList}
                               // onChange={(e) => this.handleChangeMonthList('monthList', e)}
                                type="default"
                                //initialSelectedItems={(appMonthList || []).filter(
                                //       (el) => this.returnMonthList(el.id))}
                                initialSelectedItems={filterItems.selectedMonthLists}
                                disabled={this.state.searchModel.year == null}
                                sortItems={(items) => items}
                            />
                        )}
                    </FormGroup>
                    {/*  RITM0984969 :new filter Re-submitted*/}
                    <FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
                        <FormLabel className="some-class">Re-submitted</FormLabel>

                        <Checkbox
                            id="reSubmitted"
                            // name="reSubmitted"
                            alt="searchModel"
                            key="chk_reSubmitted"
                            labelText=""
                            checked={
                                this.state.searchModel.reSubmitted}
                            onChange={(value, id) =>
                                this.updateState(id, value, "searchModel")
                            }
                        />
                    </FormGroup>
                    
                </Form>
                <div className="searchFormFooter">
                    <Button
                        className="button--max-width"
                        size="small"
                        kind="secondary"
                        onClick={this.handleClickCancelSearch}
                    >
                        Cancel
                    </Button>
                    <Button className="button--max-width" size="small" onClick={this.handleClickSearch}>
                        Search
                    </Button>
                </div>
            </div>
        );
    }

    render() {
              
        const headersDataTable = [
            { key: 'status', header: 'Status', type: 'status' },
            /*{ key: 'code', header: 'Code' },*/
            { key: 'code', header: 'TRA Code' },/*RITM0984969*/
            { key: 'workSite', header: 'Worksite' },
            { key: 'project', header: 'Project' },
            { key: 'division', header: 'Business Line' }, /*RITM0984969*/
            { key: 'startDate', header: 'Start Date', type: 'date' },
            { key: 'endDate', header: 'End Date', type: 'date' },
            /*{ key: 'courseCode', header: 'Course Code' },*/
            { key: 'courseCode', header: 'Training Title and Code' },/*RITM0984969*/
        ];
        // ///ROWS
        const rowsTrainings =
            this.state.itemList || []
                ? this.state.itemList.map((item) => {
                    const result = {};
                    result.workSite = item.workSite;
                    result.status = item.status;
                    result.idStatus = item.idStatus;
                    result.code = item.code;
                    result.project = item.project;
                    result.division = item.division;    /*RITM0984969*/
                    result.startDate = item.startDate;
                    result.endDate = item.endDate;
                    result.trainingCentre = item.trainingCenter?.name;
                    result.courseCode = (item.info == null) ? item.lihsInfo?.courseCode : item.info?.courseCode;/*RITM0984969*/
                    result.id = item.id;
                    return result;
                })
                : null;
        const paginationProps = () => ({
            page: this.state.currentPage || 1,
            totalItems: this.state.rowCount || 0,
            pageSize: this.state.pageSize || 10,
            pageSizes: [10, 20, 30, 40, 50],
            onChange: this.handleChangePaging,
        });

        const skeletonRowCount =
            this.state.rowCount > 0 && this.state.pageSize > this.state.rowCount
                ? this.state.rowCount
                : 5;

        const fileDownLoadButtonProps = (id) => {
            const item = (this.state.itemList || []).find((i) => i.id === id);
            return {
                size: 'small',
                className: 'bx--export-tab-form',
                iconDescription: 'Download Report',
                title: 'Download Report',
                kind: 'ghost',
                apiUrl: `/training/${id}/exportReport`,
                fileName: `Training_${item ? item.code : ''}.pdf`,
                onDownLoadStart: () => {
                    this.setState({
                        isLoadingNotificationFile: true,
                    });
                },
                onDownLoadEnd: () => {
                    this.setState({
                        isLoadingNotificationFile: false,
                    });
                },
                onError: (error) => {
                    showNotification.error(
                        `${entitiesLabels.ERROR}`,
                        getError(error, entitiesLabels.TRAINING, apioperation.DOWNLOAD)
                    );
                },
            };
        };

        return (
            <AppContext.Consumer>
                {({ user }) => (
                    <>
                        <PageBreadCrumb linkTo="/modules" linkText="Modules" titleLeft="Trainings" />
                        <div className="mainContainer">
                            <Loading active={this.state.isLoadingNotificationFile} withOverlay />
                            {this.state.modalCertificateCornerVisible && (this.renderCertificateCornerModal())} {/*RITM0984969*/}
                            <WFActionModal
                                show={this.state.isApprovalModalOpen}
                                title={`${this.state.approvalModalAction} Trainings`}
                                action={this.state.approvalModalAction}
                                withApprover={this.state.withApprover}
                                approver={this.state.approver}
                                approverRole={this.state.approverRole}
                                approverOptions={this.state.approvers}
                                isLoadingOperation={this.state.isLoadingWFOperation}
                                onApproverSelect={this.handleApproverSelect}
                                isLoadingOptions={this.state.isLoadingApproverOptions}
                                onCancel={this.handleCloseApprovalModal}
                                onConfirm={this.handleConfirmApprovalModal}
                                onApprovalNotesChange={this.handleApprovalNotesChange}
                                approvalNotes={this.state.approvalNotes}
                                approvalNotesRequired={this.state.approvalNotesRequired}
                                validationMessages={this.state.approvalValidationMessages}
                            />
                            <div className="header-custom-toolbar">
                                <TableToolbar>
                                    <Search
                                        readOnly
                                        light
                                        className="search cursor-pointer hiddenSearch"
                                        labelText="Search"
                                        placeHolderText="Search"
                                        id="search-1"
                                        onClick={this.toggleSearchForm}
                                    />
                                    <Button
                                        onClick={this.toggleSearchForm}
                                        className="buttonPaddingIcon"
                                        renderIcon={Data16}
                                        iconDescription="Filter"
                                    />
                                    <>
                                        <Online>
                                            <TooltipDefinition
                                                direction="left"
                                                align="center"
                                                tooltipText="Certificate Download"
                                            >
                                                <Button style={{
                                                    padding: "1rem 1rem",
                                                    border: "none",
                                                    width: "120px",
                                                    textAlign: "center"
                                                }}
                                                  iconDescription="Download Training Certificates"
                                                  onClick={this.openCertificateCornerModal}>Certificate Download</Button>
                                                
                                            </TooltipDefinition>
                                        </Online>
                                    </>
                                    {IsInRole(user, 'Administrator') || IsInRole(user, 'Compiler') ? (
                                        <Link to="/training/new">
                                            <Button renderIcon={Add20}>New </Button>
                                        </Link>
                                    ) : null}
                                </TableToolbar>
                            </div>
                            <h4 className="description-page bx--col-lg-8">
                                Current year 
                                <Dropdown
                                    id="idSearchYear"
                                    label=""
                                    name="year"
                                    alt="searchModel"
                                    items={this.state.trainingYear /* this.state.yearsList */}
                                    onChange={this.handleChangeDropDownYear /* this.onYearChange */}
                                    initialSelectedItem={this.year.toString()}
                                    selectedItem={this.state.searchModel.year ?
                                        this.state.searchModel.year.toString() :
                                        this.year.toString()}
                                    itemToString={(item) => item || ''}
                                    type="inline"
                                />
                            </h4>

                            {!this.state.isOpenSearchForm ? '' : this.renderSearchform()}

                            <DataTable
                                rows={rowsTrainings || []}
                                headers={headersDataTable}
                                useZebraStyles
                                size="compact"
                                render={({
                                    rows,
                                    headers,
                                    getHeaderProps,
                                    getRowProps,
                                    /* getTableProps, */
                                    getSelectionProps,
                                    selectedRows,
                                    getBatchActionProps,
                                }) => (
                                    <TableContainer className="bx--grid--full-width" title="">
                                        {selectedRows.length > 0 ? (
                                            <Online>
                                                <TableToolbar>
                                                    <TableToolbarContent>
                                                        <TableBatchActions {...getBatchActionProps()}>
                                                            {CanExecuteAction(
                                                                'Training',
                                                                'Reporting',
                                                                user,
                                                                selectedRows.length > 0
                                                                    ? this.getStatusId(selectedRows[0].id)
                                                                    : null,
                                                                'Submit',
                                                                this.getTraining(selectedRows)
                                                            ) ? (
                                                                <TableBatchAction
                                                                    renderIcon={Send16}
                                                                    onClick={() =>
                                                                        this.batchActionClick(
                                                                            'Submit',
                                                                            'Submit',
                                                                            'Data Approver',
                                                                            true,
                                                                            false,
                                                                            selectedRows
                                                                        )
                                                                    }
                                                                >
                                                                    Submit Report
                                                                </TableBatchAction>
                                                            ) : null}

                                                            {CanExecuteAction(
                                                                'Training',
                                                                'Reporting',
                                                                user,
                                                                selectedRows.length > 0
                                                                    ? this.getStatusId(selectedRows[0].id)
                                                                    : null,
                                                                'Approve',
                                                                this.getTraining(selectedRows)
                                                            ) ? (
                                                                <TableBatchAction
                                                                    renderIcon={CheckmarkOutline16}
                                                                    onClick={() =>
                                                                        this.batchActionClick(
                                                                            'Approve',
                                                                            'Approve',
                                                                            null, /* RUOLI_APPROVATIVI_DEV_255_RITM0565449 */
                                                                            false, /* RUOLI_APPROVATIVI_DEV_255_RITM0565449 */
                                                                            false,
                                                                            selectedRows
                                                                        )
                                                                    }
                                                                >
                                                                    Approve Report
                                                                </TableBatchAction>
                                                            ) : null}

                                                            {CanExecuteAction(
                                                                'Training',
                                                                'Reporting',
                                                                user,
                                                                selectedRows.length > 0
                                                                    ? this.getStatusId(selectedRows[0].id)
                                                                    : null,
                                                                'Consolidate',
                                                                this.getTraining(selectedRows)
                                                            ) ? (
                                                                <TableBatchAction
                                                                    renderIcon={CheckmarkOutline16}
                                                                    onClick={() =>
                                                                        this.batchActionClick(
                                                                            'Consolidate',
                                                                            'Consolidate',
                                                                            null,
                                                                            false,
                                                                            false,
                                                                            selectedRows
                                                                        )
                                                                    }
                                                                >
                                                                    Consolidate Report
                                                                </TableBatchAction>
                                                            ) : null}

                                                            {CanExecuteAction(
                                                                'Training',
                                                                'Reporting',
                                                                user,
                                                                selectedRows.length > 0
                                                                    ? this.getStatusId(selectedRows[0].id)
                                                                    : null,
                                                                'Reject',
                                                                this.getTraining(selectedRows)
                                                            ) ? (
                                                                <TableBatchAction
                                                                    renderIcon={Error16}
                                                                    onClick={() =>
                                                                        this.batchActionClick(
                                                                            'Reject',
                                                                            'Reject',
                                                                            null,
                                                                            false,
                                                                            true,
                                                                            selectedRows
                                                                        )
                                                                    }
                                                                >
                                                                    Reject Report
                                                                </TableBatchAction>
                                                            ) : null}

                                                            {CanExecuteAction(
                                                                'Training',
                                                                'Reporting',
                                                                user,
                                                                selectedRows.length > 0
                                                                    ? this.getStatusId(selectedRows[0].id)
                                                                    : null,
                                                                'RejectConsolidate',
                                                                this.getTraining(selectedRows)
                                                            ) ? (
                                                                <TableBatchAction
                                                                    renderIcon={Error16}
                                                                    onClick={() =>
                                                                        this.batchActionClick(
                                                                            'RejectConsolidate',
                                                                            'Reject',
                                                                            null,
                                                                            false,
                                                                            true,
                                                                            selectedRows
                                                                        )
                                                                    }
                                                                >
                                                                    Reject Report
                                                                </TableBatchAction>
                                                            ) : null}

                                                            {CanExecuteAction(
                                                                'Training',
                                                                'Reporting',
                                                                user,
                                                                selectedRows.length > 0
                                                                    ? this.getStatusId(selectedRows[0].id)
                                                                    : null,
                                                                'Delete',
                                                                this.getTraining(selectedRows)
                                                            ) ? (
                                                                <TableBatchAction
                                                                    renderIcon={Delete16}
                                                                    onClick={() =>
                                                                        this.batchActionClick(
                                                                            'Delete',
                                                                            'Delete',
                                                                            null,
                                                                            false,
                                                                            false,
                                                                            selectedRows
                                                                        )
                                                                    }
                                                                >
                                                                    Delete
                                                                </TableBatchAction>
                                                            ) : null}
                                                        </TableBatchActions>
                                                    </TableToolbarContent>
                                                </TableToolbar>
                                            </Online>
                                        ) : (
                                            ''
                                        )}

                                        {this.state.isLoading ? (
                                            <div className="data-table-skeleton-no-headers">
                                                <DataTableSkeleton
                                                    headers={[]}
                                                    rowCount={skeletonRowCount}
                                                    columnCount={headers.length + 1}
                                                    zebra={false}
                                                    compact={false}
                                                />
                                            </div>
                                        ) : (
                                            <Table>
                                                <TableHead>
                                                    <TableRow>
                                                            {/* <TableSelectAll {...getSelectionProps()} /> */}
                                                            <Online>
                                                                <TableSelectAll {...getSelectionProps()} />
                                                            </Online>
                                                            <Offline>
                                                                <TableSelectAll {...getSelectionProps()} disabled />
                                                            </Offline>
                                                        {/*<TableHeader className="align-center" />*/}

                                                        {headers.map((header) => (
                                                            <TableHeader
                                                                className={header.type === 'bool' ? 'align-center' : ''}
                                                                {...getHeaderProps({ header })}
                                                            >
                                                                <div
                                                                    className="sortable-header"
                                                                    onClick={() => this.handleOrderByChange(header.key)}
                                                                    role="button"
                                                                    tabIndex={0}
                                                                >
                                                                    <span className="header-title">{header.header}</span>
                                                                    <SortIcon
                                                                        show={this.state.searchModel.orderByField === header.key}
                                                                        isOrderDescending={this.state.searchModel.isOrderDescending}
                                                                    />
                                                                </div>
                                                            </TableHeader>
                                                        ))}
                                                        <TableHeader className="align-center">Actions</TableHeader>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {rows == null || rows.length === 0 ? (
                                                        <NoRecordsPlaceholder colSpan={headers.length + 2} />
                                                    ) : (
                                                        rows.map((row) => (
                                                            <TableRow {...getRowProps({ row })}>
                                                                {this.IsRowSelectable(row, selectedRows, user) ? (
                                                                    <>
                                                                        <Online>
                                                                            <TableSelectRow {...getSelectionProps({ row })} />
                                                                        </Online>
                                                                        {' '}
                                                                        <Offline>
                                                                            <TableSelectRow disabled />
                                                                        </Offline>
                                                                    </>
                                                                ) : (
                                                                    <TableCell
                                                                        key={`empty${row.id}`}
                                                                        className="tableActions align-center"
                                                                    />
                                                                )}

                                                                {row.cells.map((cell) => (
                                                                    <RenderDataTableCell
                                                                        key={cell.id}
                                                                        cell={cell}
                                                                        header={headers.find((x) => x.key === cell.info.header)}
                                                                    />
                                                                ))}

                                                                <TableCell
                                                                    key={`action-${row.id}`}
                                                                    className="tableActions align-center"
                                                                >
                                                                    <div>
                                                                        <Online>
                                                                            <FileDownLoadButton
                                                                                {...fileDownLoadButtonProps(row.id)}
                                                                                renderIcon={DocumentExport16}
                                                                            />
                                                                        </Online>
                                                                        <Link to={`/training/${row.id}`}>
                                                                            <Button
                                                                                size="small"
                                                                                renderIcon={Edit16}
                                                                                iconDescription="Edit"
                                                                                title="Edit Training"
                                                                                kind="ghost"
                                                                            />
                                                                        </Link>

                                                                        {/* <Button onClick={() => 
                                      this.confirmDelete(row.id)} 
                                      size="small" 
                                      renderIcon={Delete16} 
                                      iconDescription="Delete" 
                                      kind="ghost" /> */}
                                                                    </div>
                                                                </TableCell>
                                                            </TableRow>
                                                        ))
                                                    )}
                                                </TableBody>
                                            </Table>
                                        )}
                                    </TableContainer>
                                )}
                            />

                            <div className="footer-pagination">
                                <Pagination {...paginationProps()} />
                            </div>
                        </div>
                    </>
                )}
            </AppContext.Consumer>
        );
    }
}
TrainingList.contextType = AppContext;
TrainingList.propTypes = {
    location: PropTypes.shape({
        hash: PropTypes.string,
        key: PropTypes.string,
        pathname: PropTypes.string,
        search: PropTypes.string,
    }).isRequired,
};
